import { useQuery } from "@apollo/client/react";
import { Spin } from "antd";
import { Navigate, Outlet } from "react-router";
import { GetCurrentLoggedUserDocument } from "../gql/generated/graphqlSchema.tsx";
import { routes } from "../routes.ts";

export const GuestRoutes = () => {
  const { data, loading } = useQuery(GetCurrentLoggedUserDocument);

  if (loading) {
    return <Spin fullscreen size="large" />;
  }

  if (data?.getCurrentLoggedUser) {
    return <Navigate replace to={routes.recipes.to()} />;
  }

  return <Outlet />;
};
